import { useState } from 'react'

export const useModalState = () => {
  // Modal visibility states
  const [isOpenResetPassword, setIsOpenResetPassword] = useState(false)
  const [isOpenLoginAccessDenied, setIsOpenLoginAccessDenied] = useState(false)

  const handleToggleResetPassword = () =>
    setIsOpenResetPassword((prev) => !prev)

  const handleToggleAccessDenied = () =>
    setIsOpenLoginAccessDenied((prev) => !prev)

  return {
    // Modal states
    isOpenResetPassword,
    isOpenLoginAccessDenied,

    // Modal toggle handlers
    handleToggleResetPassword,
    handleToggleAccessDenied
  }
}
